module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAANCAYAAACZ3F9/AAAAAXNSR0IArs4c6QAAANxJREFUKBVjZAAC+4Btm////+8DYhMLmEAKWRj/FzMwMnwnVhNIHVjj3vXetxgZmJIZGBj/E6sZrBGk+OAGz+VAThmxGhnRFTr4byv5x/C/G10cnY+hEaTAIXBr9r9/jJMZGP5jlQepwSnhELQt5P9fhsX/Gf5zgBSiA5waQQrtA7dbMvz7twkYYiLoGuGBgy4B4h9c73mclYXdnJGR4Qq6PF6NIMV71rrcY2TlsmRkYFyPrBmvU5EVAlMWo33gjjqG///rQYFGtEaYIXb+272A6WQxjE8S7RS0Vx4AojM3mqQofd8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/images/corners/leave-icon.png
// module id = ../../../../../src/assets/images/corners/leave-icon.png
// module chunks = main